import useCustomerCredits from "features/subscriptions/datahooks/useCustomerCredits";
import { formatPrice } from "features/subscriptions/utils";

export default function CustomerCredits() {
  const { customerCredits } = useCustomerCredits();

  if (customerCredits) {
    return (
      <div className="flex flex-col gap-y-1.5 mt-6">
        <span className="ml-1 text-black-400 text-button-xs">Credits</span>
        <div className="flex items-center justify-between text-button-sm text-purple-600 p-2.5 bg-purple-25 border border-purple-50 rounded-2xl">
          <span>Credit balance</span>
          <span>{formatPrice(customerCredits)}</span>
        </div>
      </div>
    );
  }
}
